var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "date__actions_box" },
    _vm._l(_vm.list, function (item, index) {
      return _c(
        "div",
        {
          key: index,
          staticClass: "date__actions",
          style: {
            backgroundColor: item.bg,
            color: item.color,
            bottom: (item.index + 1) * 35 + "px",
            zIndex: item.isFrist ? 100 : 10,
            borderTop: item.type != "hope" ? "2px dotted" + item.color : "",
            borderBottom: item.type != "hope" ? "2px dotted" + item.color : "",
            borderLeft:
              item.isFrist && item.type != "hope"
                ? "2px dotted" + item.color
                : "",
            borderRight:
              item.isEnd && item.type != "hope"
                ? "2px dotted" + item.color
                : "",
          },
        },
        [
          item.isFrist
            ? _c(
                "div",
                {
                  staticClass: "flex_start flex_center_align",
                  style: {
                    color: item.color,
                  },
                },
                [
                  item.icon
                    ? _c("svg-icon", {
                        staticClass: "icon_data",
                        attrs: { "icon-class": item.icon },
                      })
                    : _vm._e(),
                  _c("span", { staticClass: "title" }, [
                    _vm._v(_vm._s(item.title)),
                  ]),
                ],
                1
              )
            : _vm._e(),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }